export default __webpack_public_path__ + "static/media/a017-9.50bdbae4.svg";